import { useEffect, useState } from 'react';
import { getCapacitySnapshot } from '../../services/capacityService';
import './capacityLine.css';

/**
 * One-line, hedged free-tier availability indicator (§6/§9,
 * docs/plans/2026-07-29-free-tier-cap-enforcement.md) sourced from the daily-written
 * `public/capacity.json`. Shown wherever the app talks about signing up for/choosing the free
 * tier (pricing modal's Free card, the pre-signup landing page) — never on generic dashboard
 * chrome, since it's only relevant to someone deciding whether free has room.
 *
 * Renders nothing while loading and nothing on fetch failure — a stale-looking gap or spinner
 * here would be worse than silence, since this line is decoration for a decision the user can
 * make without it.
 */
function CapacityLine() {
  const [snapshot, setSnapshot] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getCapacitySnapshot().then((data) => {
      if (!cancelled) setSnapshot(data);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!snapshot) {
    return null;
  }

  return (
    <p className="capacity-line">
      {snapshot.freeSlotsAvailable
        ? 'Free spots are currently available.'
        : snapshot.waitlistLengthApprox > 0
          ? `Free tier is currently full — new signups join the waitlist (~${snapshot.waitlistLengthApprox} ahead).`
          : 'Free tier is currently full — new signups join a short waitlist.'}
    </p>
  );
}

export default CapacityLine;
